import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

export const AndroidLongTextButtonFontSize = Theme.fontSizes.button - 7;

const baseStyles = {
    icon: {
        width: 10,
        height: 18
    },
    title: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.fontSizes.description,
        color: Theme.primaryTextColor,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        marginVertical: 20
    },
    boltText: { fontWeight: 'bold' },
    buttonText: {
        fontSize: Theme.fontSizes.button
    },
    buttonTextVoyo: {
        fontSize: Device.isAndroid ? AndroidLongTextButtonFontSize : Theme.fontSizes.button
    }
};

export default StyleSheet.create(baseStyles);
